var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorder5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 853.04 304.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_023._Pattern_5",
    "data-name": "023. Pattern 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.4,500H500L682.8,652.33S500,500,621.86,500h91.4L530.47,347.67S713.26,500,591.4,500Z",
    transform: "translate(-73.48 -347.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.14,500h-91.4L469.53,652.33S286.74,500,408.6,500H500L317.2,347.67S500,500,378.14,500Z",
    transform: "translate(-73.48 -347.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88,500H73.48L256.27,652.33S73.48,500,195.34,500h91.4L103.94,347.67S286.74,500,164.88,500Z",
    transform: "translate(-73.48 -347.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.12,500h91.4L743.73,347.67S926.52,500,804.66,500h-91.4l182.8,152.33S713.26,500,835.12,500Z",
    transform: "translate(-73.48 -347.67)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder5);
export default __webpack_public_path__ + "static/media/Border-5.907d8b0d52b084c63251258f21b251b7.svg";
export { ForwardRef as ReactComponent };